import { registerClientMonitoringInstrumentation } from '@kit/monitoring/instrumentation-client';

registerClientMonitoringInstrumentation();
